export default "__VITE_ASSET__DWEv7DCN__"